import React, {Component} from 'react';
import '../../Style.css';



export const webDevelopment = () => (
  
<div className="webDevWrap">
<div className="webDevLinks">
<br></br>
    <ul>
     <div className="LinkOne">
     <li><a target="_blank" href="https://malorbooks.com/"> Malor Books Website  (Wordpress, Gutenberg Block Editor, HTML, CSS, Javascript, PHP) </a>
     </li>
     </div>
     <br></br>
     <div className="LinkTwo">
     <li><a target="_blank" href="https://humanjourney.us/"> The Human Journey Website  (Wordpress, Gutenberg Block Editor, HTML, CSS, Javascript, PHP) </a>
     </li>
     </div>
     <br></br>
     <div className="LinkThree">
     <li><a target="_blank" href="https://ishk.net/"> ISHK Website  (Wordpress, Bare Bones for Divi, HTML, CSS, Javascript, PHP) </a>
     </li> 
     </div>
    <br></br>
     <div className="LinkFive">
     <li><a target="_blank" href="https://friedbergjon.github.io/frogger/"> Portfolio Project "Frogger" - Use Arrow Keys on Keyboard (HTML, CSS, Javascript)</a>
     </li>
     </div>
     <br></br>
     </ul>
    </div>
    </div>
    )
export default webDevelopment;